import type { CartItem } from '../../types/cartTypes';

export function getLineRef(item: CartItem): string {
  return item.properties?.__clientLineId ?? item.key;
}
